import { Component, OnInit, Pipe, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CoreService, HttpService, QueovalDateService } from '../../services';
import {  StageQuestionnaireModel } from '../result/result.model';
import * as FileSaver from 'file-saver';
import { DialogService } from '../../dialog';
//import { AnswerModel, ToastService } from '../../../../../dist/lib-components';
import { AnswerModel, FileModel, LearnerDetail, QResult } from '../../models';
import { ToastService } from '../../toast';
import { QuestionnaireService } from '../questionnaire.service';

@Component({
  selector: 'quest-apprenant',
  templateUrl: './apprenant.component.html',
  styleUrls: ['../questionnaire.component.css', './apprenant.component.css']
})
export class ApprenantComponent implements OnInit {

  // #region CONSTRUCTEUR
  constructor(
    protected indParam: CoreService,
    protected router: Router,
    protected http: HttpService,
    protected dialogservice: DialogService,
    protected toastservice: ToastService,
    protected activatedRouter: ActivatedRoute,
    protected questionnaireService: QuestionnaireService,
  ) { }
  // #endregion

  // #region VARIABLES GLOBALES
  model: AnswerModel = new AnswerModel();
  listQuestionnaire: StageQuestionnaireModel = new StageQuestionnaireModel();
  QuestionnaireState = QuestionnaireState;
  // #endregion

  // #region CYCLE DE VIE
  /**
   * Initialisation de la page et chagement des données
   */
  ngOnInit() {
    if (!this.questionnaireService.availableQuestionnaire) { return; }

    this.dialogservice.showSplash(false);
    // recuperation de la liste des stage non cloturé et des quesitonnaire rattachés de l'apprenant
    this.http.getHttp<QResult<StageQuestionnaireModel>>(`${this.indParam.AppParams.UrlQuestionnaireWS}api/getInfoStage/learner/${this.indParam.AppParams.LoggedUser.Ident}/`).subscribe((data: QResult<StageQuestionnaireModel>) => {
      if (!data.HasError) {
        this.listQuestionnaire.stages = data.Value.stages;

    
      } 
    });
  }
  // #endregion
  disableDl: boolean = false;
  download(stage: any, questionnaire: any, event: any) {
    event.stopPropagation();
    this.disableDl = true;
    let model: AnswerModel = new AnswerModel();
    model = new AnswerModel();
    model.Mode = "toPdf";
    model.stageId = stage.ident;
    model.modelType = questionnaire.type;
    model.learnerId = this.indParam.AppParams.LoggedUser.Ident;

    model.learnerList = new Array<LearnerDetail>();
    let learner: LearnerDetail = new LearnerDetail();
    learner.ident = this.indParam.AppParams.LoggedUser.Ident
    learner.questionnaireCompleted = true;
    model.learnerList.push(learner);

    model.modeQuestionnaire = "pdf";
    //  model.modeQuestionnaire = 'trainer';
    model.modelName = questionnaire.model;
    model.formateurName = `${this.indParam.AppParams.LoggedUser.Pre01PER} ${this.indParam.AppParams.LoggedUser.NomfaPER}`;
    this.toastservice.showInfoToast('Fichier en cours de génération ...');

    this.http.postHttp<QResult<AnswerModel>>(`${this.indParam.AppParams.UrlQuestionnaireWS}api/questionnaire/`, model).subscribe((data: QResult<AnswerModel>) => {
      if (!data.HasError) { }
      const fileModel: FileModel = new FileModel();
      fileModel.DownloadMode = 'OPENFILE';
      fileModel.FullPath = data.Value.fileToDl;
      if (data.Value.fileToDl) {

        this.http.download(`${this.indParam.AppParams.UrlQuestionnaireWS}api/Download`, fileModel).subscribe((response: any) => {
          const blob: Blob = new Blob([(response)], { type: 'application/pdf' });
          if (blob.size > 0) { 
            if (window.navigator) {
              FileSaver.saveAs(blob, this.indParam.AppParams.LoggedUser.Ident + '.pdf');
            } else {
              const objectUrl = URL.createObjectURL(blob);
              window.open(objectUrl);
            }
          }
          this.indParam.showSplash(false);
          this.disableDl = false;
        });

      } else {
        this.disableDl = false;
      }
      this.indParam.showSplash(false);
    });
  }


  // #region FONCTIONS PUBLIQUES
  /**
   * Rediretion vers le questionnaire sélectionné
   * @param questionnaireModel
   * @param stage
   * @param questionnaireType
   */
  goTo(questionnaireModel: string, stage: string, questionnaireType: string, isTimedUp: boolean) {
    if (!isTimedUp) {
      this.model.stageId = stage;
      this.model.modelType = questionnaireType;
      this.model.learnerId = this.indParam.AppParams.LoggedUser.Ident;
      this.model.modelName = questionnaireModel;
      this.model.modeQuestionnaire = 'learner';
      // envoi des informations du stage au la page du questionnaire
      this.questionnaireService.setNavigationData(this.model);
      this.router.navigate(['../questionnaire/answer'], { relativeTo: this.activatedRouter });
    }
  }

  /**
   * Gestion des accordéons
   * @param element
   */
  accordion(element: any) {
    element.classList.toggle('accordionActive');
    const panel = element.nextElementSibling;
    if (!panel.style.maxHeight || panel.style.maxHeight !== '0px') {
      panel.style.maxHeight = '0px';
    } else {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  }

  /**
   * Retour vers le menu principal
    */
  goback() {
    //this.router.navigate(['webform/home']);
  }

  // #endregion
}



@Pipe({
  name: 'DateBadge'
})
export class QDateBadgePipe implements PipeTransform {

  constructor(
    protected indParam: CoreService,
    protected qDateService: QueovalDateService,
  ) { }

  transform(value: string): string {
    const options: any = { weekday: "long", year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "numeric" };
    return new Intl.DateTimeFormat(this.indParam.AppParams.culture, options).format(new Date(value));
  }
}


export enum QuestionnaireState {
  Marked,
  UnderCorrection,
  NoMark,
  ContinueCertification,
  CertificationCompleted,
  TimeLocked,
}
